import {EMPTY_OBJECT_STRING} from "@Base/constants/constants";

export const setLocalStorage = (key: string, data: any) =>
  window.localStorage.setItem(key, JSON.stringify(data || EMPTY_OBJECT_STRING))

export const getLocalStorage = (key: string) => JSON.parse(window.localStorage.getItem(key || '') || '[]')

export const removeLocalStorage = (key: string) => window.localStorage.removeItem(key || '')